export const GoogleMapsConfig = {
		apiKey: document.location.hostname.indexOf("healthsun.com")!==-1 ? "AIzaSyAuSdxBV0uUe9XKa6zhGpTr94j9lV_F8Mw" : "AIzaSyDQzvk6Cdfjri--R96AGxR6dco72E7bP9s"
}
